import Mac88 from '../../assets/images/provider_img/mac88.webp';
import Mac88Virtual from '../../assets/images/provider_img/mac88-virtual.webp';
import FunGames from '../../assets/images/provider_img/fun-games.webp';
import Evolution from '../../assets/images/provider_img/evolution-gaming.webp';
import Spribe from '../../assets/images/provider_img/spribe.webp';
import Turbo from '../../assets/images/provider_img/turbo-games.webp';
import Smartsoft from '../../assets/images/provider_img/smartsoft.webp';
import Ezugi from '../../assets/images/provider_img/ezugi.webp';
import Jili from '../../assets/images/provider_img/Jili.webp';
import AeSexy from '../../assets/images/provider_img/sexy.webp';
import Playtech from '../../assets/images/provider_img/playtech.webp';
import Betsoft from '../../assets/images/provider_img/betsoft.webp';
import Gamzix from '../../assets/images/provider_img/gamzix.webp';
import BetGames from '../../assets/images/provider_img/betgamestv.webp';
import Winfinity from '../../assets/images/provider_img/winfinity.webp';
import Live88 from '../../assets/images/provider_img/live88.webp';
import King from '../../assets/images/provider_img/Kingmaker Thumbnail.png';
import RG from '../../assets/images/provider_img/royal-gaming.webp';

export const HomeProvidersIcons = [
  { icon: Mac88, subProviderName: 'MAC88' },
  { icon: FunGames, subProviderName: 'FUN GAMES' },
  { icon: Mac88Virtual, subProviderName: 'MAC88 VIRTUALS' },
  { icon: Spribe, subProviderName: 'SPRIBE' },
  { icon: Evolution, subProviderName: 'EVOLUTION' },
  { icon: Turbo, subProviderName: 'TURBO' },
  { icon: Smartsoft, subProviderName: 'SMARTSOFT GAMING' },
  { icon: Ezugi, subProviderName: 'EZUGI' },
  { icon: Jili, subProviderName: 'JILI' },
  { icon: AeSexy, subProviderName: 'AE SEXY' },
  { icon: Playtech, subProviderName: 'PLAYTECH' },
  { icon: Betsoft, subProviderName: 'BETSOFT' },
  { icon: Gamzix, subProviderName: 'GAMZIX' },
  { icon: BetGames, subProviderName: 'BetGames_TV' },
  { icon: Winfinity, subProviderName: 'WINFINITY' },
  { icon: Live88, subProviderName: 'Bombay Live' },
  { icon: King, subProviderName: 'KINGMAKER' },
  { icon: RG, subProviderName: 'ROYAL GAMING' },
];

export const HomeMobProvidersIcons = [
  { icon: Mac88, subProviderName: 'MAC88' },
  { icon: Evolution, subProviderName: 'EVOLUTION' },
  { icon: Turbo, subProviderName: 'TURBO' },
  { icon: Smartsoft, subProviderName: 'SMARTSOFT GAMING' },
  { icon: Playtech, subProviderName: 'PLAYTECH' },
  { icon: Jili, subProviderName: 'JILI' },
  { icon: FunGames, subProviderName: 'FUN GAMES' },
  { icon: Spribe, subProviderName: 'SPRIBE' },
  { icon: AeSexy, subProviderName: 'AE SEXY' },
  { icon: Winfinity, subProviderName: 'WINFINITY' },
  { icon: Gamzix, subProviderName: 'GAMZIX' },
  { icon: BetGames, subProviderName: 'BetGames_TV' },
  { icon: Mac88Virtual, subProviderName: 'MAC88 VIRTUALS' },
  { icon: Ezugi, subProviderName: 'EZUGI' },
  { icon: Betsoft, subProviderName: 'BETSOFT' },
  { icon: Live88, subProviderName: 'Bombay Live' },
  { icon: King, subProviderName: 'KINGMAKER' },
  { icon: RG, subProviderName: 'ROYAL GAMING' },
];
